import SEO from "./SEO";

export default function SEOMovie({ movie }) {
  const image =
    movie.thumbnail_url ||
    "https://cdn.papertigercinema.com/static/ptc_lgo.png";

  const title =
    movie.seo_title ||
    `Watch ${movie.title} (${movie.year}) Free | Paper Tiger Cinema`;

  const description =
    movie.seo_description ||
    movie.overview?.slice(0, 160) ||
    `Watch ${movie.title} (${movie.year}) free online on Paper Tiger Cinema.`;

  return (
    <SEO
      title={title}
      description={description}
      url={`https://papertigercinema.com/movies/${movie.slug}`}
      image={image}
      type="video.movie"
    />
  );
}